import { render, staticRenderFns } from "./itemgroups.vue?vue&type=template&id=b55f0a60&scoped=true&"
import script from "./itemgroups.vue?vue&type=script&lang=js&"
export * from "./itemgroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55f0a60",
  null
  
)

export default component.exports